<template>
	<div class="card">
    <div class="form-group row" style="margin: 9px;">
        <div class="col-sm-12 custome_image">
            <img :src="contactDetails.image">
        </div>
        <table id="my-table" class="table table-striped table-bordered">
            <tbody>
                <tr >
                    <td>Name:</td>
                    <td>{{contactDetails.name}}</td>
                    <td>Mobile Number</td>
                    <td>{{contactDetails.mobile_number}}</td>
                    <td>Email</td>
                    <td>{{contactDetails.email}}</td>
                </tr>
                  <tr >
                    <td>Father Name:</td>
                    <td>{{contactDetails.father_name}}</td>
                    <td>Mother Name</td>
                    <td>{{contactDetails.mother_name}}</td>
                    <td>Spouse Name</td>
                    <td>{{contactDetails.spouse_name}}</td>
                </tr>
                <tr >
                    <td>District:</td>
                    <td>{{contactDetails.district_name}}</td>
                    <td>Subdistric</td>
                    <td>{{contactDetails.subdistrict_name}}</td>
                    <td>Area/Village</td>
                    <td>{{contactDetails.area_village}}</td>
                </tr>
                <tr >
                    <td>Ward/Union:</td>
                    <td>{{contactDetails.ward_union}}</td>
                    <td>Street/Para</td>
                    <td>{{contactDetails.street_para}}</td>
                    <td>Post Office</td>
                    <td>{{contactDetails.post_ofiice}}</td>
                </tr>
                <tr >
                    <td>Occupation:</td>
                    <td>{{contactDetails.occupation}}</td>
                    <td>Company</td>
                    <td>{{contactDetails.company}}</td>
                    <td>Designation</td>
                    <td>{{contactDetails.designation}}</td>
                </tr>
                <tr >
                    <td>Nid:</td>
                    <td>{{contactDetails.nid}}</td>
                    <td>Birthday</td>
                    <td>{{contactDetails.birthday}}</td>
                    <td>Contact Number</td>
                    <td>{{contactDetails.contact_number}}</td>
                </tr>

            </tbody>
        </table>
    </div>
	</div>
</template>
<script>
import Vue from "vue";
import axios from "axios"
import WorkersReport from '../dashboard/workersreportChange'
import Loader from '../common/Loader'
import Details from '../recuiting/workersinfo/details'
import { CONTACT_DETAILS,ALL_VISA,DELETE_VISA,GETLASTID } from "../../store/action.type"
import { mapState,mapGetters } from "vuex"
import AddInvoice from './addInvoice'
export default {
    data(){
        return {
        	id:this.$route.params.id,
            largeModal2: false,
            contacts:[],
            permission:'',
            loading:false,
           
            search:{
                search_item:'',
                type:''
            },
            loader:false,
            newInvoice:{
                date:'',
                account_id:'',
                agent_id:'',
                customer_id:'',
                visa_id:'',
                invoice_number:'',
                due_date:'',
                customer_id:'',
                commission_type:'',
                commission_amount:'',
                shipping_charge:'',
                adjustment:0,
                total:'',
                personal_note:'',
                customer_note:'',
                invoice_items:[{
                    project_id:'',
                    quantity:1,
                    rate:0,
                    discount:0,
                    tax:0,
                    amount:0,
                    purpose_id:''
                }],
            },
            list:{},
            lists:{},
            workers:{},
        }
    },
    methods:{
       print: function(elem) {
         var mywindow = window.open('', 'PRINT', 'height=800,width=1200');

          mywindow.document.write('<html><head><title>' + document.title  + '</title>');
          mywindow.document.write('</head><body >');
          mywindow.document.write('<h1>' + document.title  + '</h1>');
          mywindow.document.write(document.getElementById(elem).innerHTML);
          mywindow.document.write('</body></html>');

          mywindow.document.close(); // necessary for IE >= 10
          mywindow.focus(); // necessary for IE >= 10*/

          mywindow.print();
          mywindow.close();

          return true;
  
      },
       viewModal(type,index,id){
            this.loader = true;
            axios.get("/api/visa/show/"+id)
            .then(response => {
                this.loader = false;
                this.list = response.data;
            })
            .catch(function(error) {
                this.loader = true;
            });
            
            this.list.entryType = type;
            this.$refs.details_modal.openModal();
        },
         viewReport(type){
             axios.get("api/worker/report/"+type+'/'+this.contactDetails.id+'/'+this.contactDetails.type)
              .then(response => {
                  this.workers = response.data
                   this.$refs.view_modal.openModal()
              })
              .catch(error => {
                  reject(error)
              });
            //this.lists = listArray;
           
         },
        addInvoiceModal(account_id,visa){
            this.newInvoice.account_id=account_id;
            this.newInvoice.customer_id=visa.user_id;
            this.newInvoice.visa_id=visa.id;
            this.newInvoice.agent_id=visa.agent_id;
            this.newInvoice.date='';
            this.newInvoice.due_date='';
            this.newInvoice.total='';
            this.newInvoice.personal_note='';
            this.newInvoice.customer_note='';
            this.$refs.add_invoice_modal.openModal()
        },
        
        getResults() {

            this.$store.dispatch('CONTACT_DETAILS',this.id)
            .then(response=>{
                   
            })
            .catch(error=>{
                this.loading=true;        
            });

        },
        
        getPermission(){
            this.$store.dispatch('ALL_USER_ROLE2')
            .then(response=>{
                this.permission = response.data.permission
            })
        }
    },
    mounted(){
        this.getResults()
    },
    computed: {
        totalinvoice(){
            return (
                (parseFloat(this.rbl_p_invoice)+
                parseFloat(this.rbl_r_invoice)+
                parseFloat(this.amir_p_invoice)+
                parseFloat(this.amir_r_invoice)))
        },
        totaldue(){
            return (
                (parseFloat(this.rbl_p_invoice_due)+
                parseFloat(this.rbl_r_invoice_due)+
                parseFloat(this.amir_p_invoice_due)+
                parseFloat(this.amir_r_invoice_due)))
        },
        ...mapGetters(["contactDetails"]),
    },
    components: {
        Loader,
        AddInvoice,
        WorkersReport,
        Details
    }

}
</script>

<style>
.worker_report_table_td{
  cursor: pointer;
}
.custome_image{
    text-align: center;
    position: relative;
    
}
.custome_image>img{
    width: 100px;
    height: 100px;
    object-fit: cover;
    border: 1px solid;
    border-radius: 50%;
}
 .actn{
     margin-left: 10px;
     cursor: pointer;
 }
 .contct{
     padding-bottom: 10px;
     padding-top: 10px
 }
 .contct-b{
     margin-bottom: 10px;
     margin-top: 10px
 }
 .load{
     margin-left: 50%;
 }
 .table_fields>td>span{
 	cursor:pointer;
 }
</style>
